module.exports = "//static.hsappstatic.net/ui-addon-upgrades/static-9.3513/js/img/Service.svg"